import { useEffect, useState } from 'react';

/**
 * Returns `false` during SSR and the first client render, then flips to `true` once the
 * component has mounted (hydrated).
 *
 * Use it for two-pass rendering: emit the SSR-visible variant on the first pass — e.g., an
 * accordion rendered expanded so its content lands in the crawlable HTML — then switch to the
 * interactive default after hydration. Because the first client render still returns the SSR
 * variant, the markup matches, and there is no hydration mismatch; the effect-driven re-render
 * then applies the client default.
 */
export const useIsHydrated = (): boolean => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
};

export default useIsHydrated;
